import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    options: Object
  }

  connect() {
    let options = { plugins: ['remove_button'], maxOptions: null, clearAfterSelect: true, ...this.optionsValue }

    this.tom = new TomSelect(this.element, options)
  }

  disconnect() {
    if (this.tom) {
      this.tom.destroy()
    }
  }
}

